<ion-content class="qvs-maintenance--wrapper">
  <div class="qvs-maintenance">
    <img class="qvs-maintenance__logo" [src]="logo | assetByColorMode" alt="Logo" />
    <picture class="qvs-maintenance__img">
      <source
        media="(max-width: 1023px)"
        [srcset]="mobileImage | assetByColorMode"
      />
      <source
        media="(min-width: 1024px)"
        [srcset]="desktopImage | assetByColorMode"
      />
      <img
        [src]="mobileImage | assetByColorMode"
        alt="Maintenance"
      />
    </picture>
    <h2 class="qvs-maintenance__title">{{ 'maintenance.TITLE' | translate }}</h2>
    <p class="qvs-maintenance__text">{{ maintenanceMessage$ | async }}</p>
    <ion-button class="qvs-maintenance__button" href="{{ contactLink }}">
      {{ 'maintenance.CONTACT_US' | translate }}
    </ion-button>
  </div>
</ion-content>
